import { REST_URLS } from "../../common-utilities/utils/end-points/cf-approval";
import { HTTP_METHODS, invokeApi } from "./http-service";
import { clearOfflineData, setOfflineData } from "./offline-services";
import { INTRANETHOSTNAME } from "../../common-utilities/utils/end-points";
import { tokenMainKeys } from "../../../utils/constants";

export const redirectToIntranetPortal = () => {
  clearOfflineData(tokenMainKeys.cfApproval, "user");
  clearOfflineData(tokenMainKeys.cfApproval, "tokens");
  setTimeout(() => {
    window.location.href = "/";
  }, 200);
};

export const getUserDetailsFromIntranet = (
  Authorization,
  customLogic,
  tokens
) => {
  invokeApi(
    HTTP_METHODS.POST,
    `${INTRANETHOSTNAME}${REST_URLS.INTRANET_LOGIN}`,
    null,
    null,
    Authorization
  )
    .then((res) => {
      if (res?.message) {
        redirectToIntranetPortal();
        return;
      }
      if (tokens) {
        setOfflineData("tokens", tokens);
      }
      const role = res?.role?.toUpperCase();
      setOfflineData("user", { ...res, role });
      if (typeof customLogic === "function") {
        customLogic(res);
      }
    })
    .catch(() => {
      redirectToIntranetPortal();
    });
};
